import { Box } from "@material-ui/core";
import { Brightness1 } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useProfessionalLogState } from "../../../context/profesionalPage/professionalLog/professionalLogState";
import "./activeProfessionalsListStyle.scss";
import { GetActiveProfessionalsList } from "../../../services/medilinePrepaidService";
import { useStateAuthValue } from "../../../context/Auth/AuthState";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { act } from "react";
const ActiveProfessionalsList = () => {
  const [activeProfessionals, setActiveProfessionals] = useState([]);
  const [logedOutProfessionals, setLogedOutProfessionals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [{ userData, userToken }] = useStateAuthValue();
  const getActiveProfessionalsList = async () => {
    if (!navigator.onLine){
      setLoading(true);
      return;

    }
    let specialityId = userData?.professional_dto?.specialties[0]?.id;
    if (!specialityId || specialityId == "") return;
    await GetActiveProfessionalsList(userToken,specialityId).then(
      ({ data }) => {
        let _activeProfessionals = data.activeProfessionals;
        let _logedOutProfessionals = data.logedOutProfessionals;
      
        
        setLoading(false);
        if (_activeProfessionals && _logedOutProfessionals) {
          const sortedActiveProfessionals = _activeProfessionals.sort(
            (a, b) => new Date(b.last_active) - new Date(a.last_active)
          );

          const sortedLogedOutProfessionals = _logedOutProfessionals.sort(
            (a, b) => new Date(b.last_logout) - new Date(a.last_logout)
          );

          setActiveProfessionals(sortedActiveProfessionals);
          setLogedOutProfessionals(sortedLogedOutProfessionals);
        }
      }
    );
  };
  useEffect(() => {
    const interval = setInterval(() => {
      getActiveProfessionalsList();
    }, 5000); // Se ejecuta cada 5 segundos

    return () => clearInterval(interval); // Limpieza al desmontar
  }, [userToken]);
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}/${month} ${hours}:${minutes}`;
  };

  const renderList = (currentLis, isLogOut) => {
    if (!currentLis?.length)
      return (
        <Box
          width={"2rem"}
          height={"2px"}
          borderRadius={"10px"}
          bgcolor={"#002c54"}
          mt={"1rem"}
        ></Box>
      );

    return currentLis?.map(({ event, id, name, last_active,last_logout }) => {
      let isActive = event != "LogOut" && event != "EndedUnexpectedly";
      return (
        <Box className="item" key={id}>
          <span>{name}</span>
          <Box className="last-active">
            <span>
              {isLogOut && last_logout
                ? formatDate(last_logout)
                : formatDate(last_active)}
            </span>
            {!isLogOut && (
              <Brightness1
                style={{ color: isActive ? "#00cc00" : "#ff0000" }}
              ></Brightness1>
            )}
          </Box>
        </Box>
      );
    });
  };
  return (
    <Box className="active-professionals-list">
        <Box className="title">
        <h2>Profesionales en línea</h2>
      </Box>
      {loading ? (
        <Box width={"20rem"}>
          <LoadingSpinner></LoadingSpinner>
        </Box>
      ) : (
        <>
          <Box className="header">
            <h2>Profesional</h2>
            <h2>Ult. Actividad</h2>
          </Box>
          {renderList(activeProfessionals, false)}
          <Box className="header">
            <h2>Profesional</h2>
            <h2>Ult. Cierre Sesión</h2>
          </Box>
          {renderList(logedOutProfessionals, true)}
        </>
      )}
    </Box>
  );
};

export default ActiveProfessionalsList;
